module.exports = __webpack_public_path__ + "images/for_company_page/title-number3_9ff82a6b03a0d4389b37c68b262a1ff8.jpg";